// src/lib/computeHeatBonuses.js
export function computeHeatBonuses(heat) {
    const bonuses = {};
    if (!heat || !Array.isArray(heat.results)) return bonuses;

    // Ta ut genomförda i placeringsordning
    const finished = heat.results
        .filter((r) => r.status === "completed" && typeof r.position === "number")
        .sort((a, b) => a.position - b.position);

    if (finished.length < 3) return bonuses;

    // rider_id -> team ('home' | 'away') enligt heatets riders
    const riderTeams = {};
    Object.values(heat.riders || {}).forEach((r) => {
        if (r?.rider_id) riderTeams[String(r.rider_id)] = r.team;
    });

    // “1-2” eller “2-3” i samma lag => +1 bonus till den sämre placerade av paret
    if (riderTeams[String(finished[0].rider_id)] === riderTeams[String(finished[1].rider_id)]) {
        bonuses[String(finished[1].rider_id)] = 1;
    }
    if (riderTeams[String(finished[1].rider_id)] === riderTeams[String(finished[2].rider_id)]) {
        bonuses[String(finished[2].rider_id)] = 1;
    }

    return bonuses;
}
